import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import TableTab from "../../tabs/table-tab";
import { getDateCategory, NameOnlyColumn } from "../filterModalUtil";
import { FilterModel } from "../FilterModel";
import { ListData } from "../../../models/ListData";
import { ListQuery } from "../../../models/ListQuery";
import { DEF_PG_SIZE_SUB } from "../../../constants/maximum-page-size";

interface CategoryProps {
    onNext: (event: any) => void ;
    onBack: (event: any) => void;
    categoryFilter?: FilterModel;
    filterModalTrigger: string;
}

export const Category: FC<CategoryProps> = ({ onBack, onNext, categoryFilter, filterModalTrigger }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.selectAFilterTypeCategory);
    const { values, setFieldValue } = useFormikContext<any>();
    const [dataRefresh, setDataRefresh] = useState(() => (dataMethod?: (query?: ListQuery) => Promise<ListData>) => { return });
    const manualDataRefresh = (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => {
        setDataRefresh(() => refreshData);
    }

    useEffect(() => { 
        dataRefresh((listParameters) => getDateCategory(translate, categoryFilter, listParameters));
    }, [categoryFilter]);

    const onRowClicked = (rowData: any) => {
        const fakeOnclickEvent = {} as React.MouseEvent<HTMLButtonElement, MouseEvent>
        const eventWithData = { ...fakeOnclickEvent, elementSysname: rowData.elementSysname, name: rowData.nameOriginal };
        setFieldValue('categoryElementSysname',rowData.elementSysname);
        onNext(eventWithData);
    }

    return <div className="flex flex-col pt-3 pr-3 h-full">
        <div className="flex flex-col flex-1 min-h-0 overflow-auto">
            <TableContextProvider
                usePagination
                useTable
                dataMethod={(listParameters) => getDateCategory(translate, categoryFilter, listParameters )}
                tableDescriptor={NameOnlyColumn}
                manualDataRefresh={manualDataRefresh}
                disableSearch={false}
                useSearch={true}
                maxPageSize={DEF_PG_SIZE_SUB}>
                <TableTab
                    title={title}
                    tableHeight="100%"
                    selectRows={false}
                    onRowClicked={(data) => onRowClicked(data)}
                    tableId={'filterCategoryTable'}
                    cyName="categoryStep" />
            </TableContextProvider>
        </div>
        <div className="flex flex-row justify-end pt-3 pb-3">
            {!filterModalTrigger ?
                <div className="flex flex-row">
                    <button
                        className={`secondary secondary-inverse py-1 px-5`}
                        type="button"
                        onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
                </div> : null}
            <div className="flex flex-row justify-end pl-3">
                <button
                    className={`py-1 px-5 secondary  ${values.categoryElementSysname ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type='button'
                    onClick={onNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}